import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { useHistory } from 'react-router-dom';
import AddIcon from '@material-ui/icons/Add';
import CancelIcon from '@material-ui/icons/Cancel';
import SaveIcon from "@material-ui/icons/Save";
import {
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Grid,
    Divider,
    Switch,
    TextField,
    Typography,
    colors,
    Table,
    TableHead,
    TableCell,
    TableBody,
    TableRow
} from '@material-ui/core';
import { add_showroom_timetable } from '../../../../api/API';


const useStyles = makeStyles(theme => ({
    root: {},

    saveButton: {
        color: theme.palette.white,
        backgroundColor: colors.green[600],
        '&:hover': {
            backgroundColor: colors.green[900]
        },

    },

    flexend: {
        justifyContent: 'flex-end',
    },
    leftIcon: {
        marginRight: theme.spacing.unit,
    },
}));

export default function From(props) {

    const { profile, className, showroom_agencies, is_special, ...rest } = props;

    const classes = useStyles();

    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [agencies, setAgencies] = useState(showroom_agencies);
    const [max_appointment, setMaxAppointment] = useState(props.max_appointment);
    const [values, setValues] = useState({
        day: 0,
        type: 1,
        property_id: props.showroom_id,
        is_special: is_special

    });

    useEffect(() => {
        setAgencies(props.showroom_agencies);
        setMaxAppointment(props.max_appointment);

        let extra_values = {};
        for (let i = 0; i < props.showroom_agencies.length; i++) {
            extra_values['agency_slot_' + props.showroom_agencies[i].agency_id] = "0";
        }
        setValues({
            ...values,
            ...extra_values
        });
    }, []);

    const history = useHistory();

    const handleChange = event => {
        event.persist();

        setValues({
            ...values,
            [event.target.name]:
                event.target.type === 'checkbox'
                    ? event.target.checked
                    : event.target.value
        });

    };

    const checkTotalAppointment = () => {
        let total_agency_booking = 0;
        for (let i = 0; i < agencies.length; i++) {
            if (values['agency_slot_' + agencies[i].agency_id]) {
                total_agency_booking += parseInt(values['agency_slot_' + agencies[i].agency_id]);
            }
        }
        console.log("Total : " + total_agency_booking);
        console.log("max : " + max_appointment);
        if (total_agency_booking > max_appointment) {
            alert("Total number of appointments must not exceed " + max_appointment);
            return false;
        }

        return true;

    }

    const handleSubmit = event => {
        event.preventDefault();

        if (is_special && values.title == "") {
            alert("Please enter a title");
            return;
        }
        if (checkTotalAppointment()) {
            add_showroom_timetable(values);
            history.push("/showroom/detailshowroom/" + props.showroom_id);
        }
    };

    const handleSnackbarClose = () => {
        setOpenSnackbar(false);
    };

    const day = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];


    return (
        <div>

            <form onSubmit={handleSubmit}>
                <Card
                    {...rest}
                    className={clsx(classes.root, className)}
                >
                    <CardHeader title="Create New Timetable" />
                    <Divider />
                    <CardContent>
                        <Grid
                            container
                            spacing={4}
                        >
                            {is_special ?
                                <React.Fragment>
                                    <Grid
                                        item
                                        md={6}
                                        xs={12}
                                    >
                                        <TextField
                                            fullWidth
                                            label="Title"

                                            required={is_special ? 1: 0}
                                            name="title"
                                            onChange={handleChange}
                                            value={values.title}
                                            variant="outlined"
                                        >

                                        </TextField>
                                    </Grid>
                                    <Grid
                                        item
                                        md={6}
                                        xs={12}
                                    >
                                        <TextField
                                            fullWidth
                                            label="Date"
                                            name="date"
                                            type="date"
                                            onChange={handleChange}
                                            value={values.date}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        >
                                        </TextField>
                                    </Grid>
                                </React.Fragment>
                                : ''}
                            <Grid
                                item
                                md={6}
                                xs={12}
                            >
                                <TextField
                                    fullWidth
                                    label="Type"
                                    name="type"
                                    select
                                    onChange={handleChange}
                                    value={values.type}
                                    variant="outlined"
                                >
                                    <option
                                        key="1"
                                        value="1"
                                    >
                                        Pre-allocated
                                    </option>
                                    <option
                                        key="2"
                                        value="2"
                                    >
                                        First come first serve
                                    </option>
                                </TextField>
                            </Grid>
                            {!is_special ?
                                <Grid
                                    item
                                    md={6}
                                    xs={12}
                                >
                                    <TextField
                                        fullWidth
                                        label="Day"
                                        name="day"
                                        onChange={handleChange}
                                        select
                                        SelectProps={{ native: true }}
                                        value={values.day}
                                        variant="outlined"
                                    >
                                        {day.map((day, i) => (
                                            <option
                                                key={i}
                                                value={i}
                                            >
                                                {day}
                                            </option>
                                        ))}
                                    </TextField>

                                </Grid> : ''}


                            <Grid
                                item
                                md={6}
                                xs={12}
                            >
                                <TextField
                                    fullWidth
                                    label="Start Time"
                                    name="start_time"
                                    onChange={handleChange}
                                    type="time"
                                    step="15"
                                    value={values.startdate}
                                    variant="outlined"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />

                            </Grid>
                            <Grid
                                item
                                md={6}
                                xs={12}
                            >
                                <TextField
                                    fullWidth
                                    label="End Time"
                                    name="end_time"
                                    onChange={handleChange}
                                    type="time"
                                    value={values.enddate}
                                    variant="outlined"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />

                            </Grid>

                            {/* {
                                values.type == 2 ?
                                    <React.Fragment>
                                        <Grid
                                            item
                                            md={6}
                                            xs={12}
                                        >
                                            <TextField
                                                fullWidth
                                                label="Max Slots"
                                                name="max_appointment"
                                                onChange={handleChange}
                                                type="number"
                                                value={values.max_appointment}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />

                                        </Grid>
                                        <Grid
                                            item
                                            md={6}
                                            xs={12}
                                        >
                                            <TextField
                                                fullWidth
                                                label="Max Pax"
                                                name="max_pax"
                                                onChange={handleChange}
                                                type="number"
                                                value={values.max_pax}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />

                                        </Grid>

                                    </React.Fragment>
                                    : ''} */}



                        </Grid>
                    </CardContent>
                    <Divider />
                    {/* <SuccessSnackbar
            onClose={handleSnackbarClose}
            open={openSnackbar}
            /> */}
                </Card>

                <Card
                    {...rest}
                    className={clsx(classes.root, className)}
                >

                    {
                        values.type == 1 ?
                            <React.Fragment>
                                <CardHeader title="Agencies" />
                                <Divider />

                                <CardContent>

                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Agency</TableCell>
                                                <TableCell>Allocated Guests</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        {agencies ?
                                            <TableBody>
                                                {agencies.map(row => (
                                                    <TableRow>
                                                        <TableCell>{row.name}</TableCell>
                                                        <TableCell>
                                                            <TextField
                                                                type="number"
                                                                value={values['agency_slot_' + row.agency_id]}
                                                                label="slots"
                                                                name={"agency_slot_" + row.agency_id}
                                                                onChange={handleChange}
                                                            ></TextField>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody> : ''}
                                    </Table>


                                </CardContent>
                            </React.Fragment>
                            : ''}
                    <Divider />
                    <CardActions className={classes.flexend}>
                        <Button
                            variant="contained"
                            style={{
                                backgroundColor: "black"
                            }}
                            onClick={() => {
                                history.goBack();
                            }}
                        >
                            <CancelIcon className={classes.leftIcon} />
                        Cancel
                </Button>
                        <Button
                            className={classes}
                            type="submit"
                            variant="contained"

                        >
                            <SaveIcon className={classes.leftIcon} />
                            Save Changes
                </Button>
                    </CardActions>
                    {/* <SuccessSnackbar
            onClose={handleSnackbarClose}
            open={openSnackbar}
            /> */}
                </Card>

            </form>



        </div>
    )
}

